import React, { useState } from 'react';
import propTypes from 'prop-types';
import { isNil } from 'lodash';
import { Dropdown, Stack } from 'office-ui-fabric-react';
import SearchTypeaheadPicker from './SearchTypeaheadPicker';
import FormikTypeaheadPicker from './FormikTypeaheadPicker';
import { operatorOptions } from '../../constants';
import styles from './TypeaheadPicker.styles';

const FormikTypeaheadPickerWithOperator = ({
  field,
  form,
  Typeahead,
  showErrors,
  showOperator,
  ...others
}) => {
  const [operatorState, setOperatorState] = useState(
    field.value?.operator ? field.value.operator : 'equals',
  );

  return (
    <Stack horizontal>
      {showOperator && (
        <Stack.Item className={styles.rightPadding}>
          <Dropdown
            aria-label="Operator Dropdown"
            options={operatorOptions}
            defaultSelectedKey={operatorState}
            onChange={(event, option) => {
              setOperatorState(option.key);
              if (!isNil(field.value)) {
                form.setFieldValue(field.name, { ...field.value, operator: option.key });
              }
            }}
          />
        </Stack.Item>
      )}

      <Stack.Item grow={1}>
        <FormikTypeaheadPicker
          field={field}
          form={form}
          showErrors
          Typeahead={Typeahead}
          onChange={newValue => {
            if (!isNil(newValue)) {
              // do this only when user selects an option(other than Any)
              form.setFieldValue(field.name, {
                ...newValue,
                operator: showOperator ? operatorState : undefined,
              });
            }
          }}
          {...others}
        />
      </Stack.Item>
    </Stack>
  );
};

FormikTypeaheadPickerWithOperator.propTypes = {
  field: propTypes.shape({
    name: propTypes.string.isRequired,
    value: propTypes.any,
  }).isRequired,
  form: propTypes.shape({
    setFieldValue: propTypes.func.isRequired,
    errors: propTypes.object.isRequired,
  }).isRequired,
  Typeahead: propTypes.func,
  showErrors: propTypes.bool,
  showOperator: propTypes.bool,
};

FormikTypeaheadPickerWithOperator.defaultProps = {
  Typeahead: SearchTypeaheadPicker,
  showErrors: false,
  showOperator: false,
};

export default FormikTypeaheadPickerWithOperator;
